import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// 環境変数が設定されていればそちらを使い、無ければ本番の値を使う。
// つまり .env を置かずにビルドすれば、これまでと完全に同じ動作になる。
//
// 開発用プロジェクト(miyabicompany-manager-dev)で動かしたいときは
// .env.development.local を作る(雛形: .env.development.local.example)。
// このファイルは npm start のときだけ読まれ、npm run build には影響しない。
const env = process.env;

const firebaseConfig = {
  apiKey:            env.REACT_APP_FB_API_KEY             || "AIzaSyAkubLcT4WmdywqksS7V7XWo6iWw_Xp7CE",
  authDomain:        env.REACT_APP_FB_AUTH_DOMAIN         || "miyabicompany-manager.firebaseapp.com",
  projectId:         env.REACT_APP_FB_PROJECT_ID          || "miyabicompany-manager",
  storageBucket:     env.REACT_APP_FB_STORAGE_BUCKET      || "miyabicompany-manager.firebasestorage.app",
  messagingSenderId: env.REACT_APP_FB_MESSAGING_SENDER_ID || "601275056675",
  appId:             env.REACT_APP_FB_APP_ID              || "1:601275056675:web:cd7457fb2849e092162796",
  measurementId:     env.REACT_APP_FB_MEASUREMENT_ID      || "G-0Y3ME33LFZ"
};

// 本番以外に接続しているときは、気づけるようにコンソールへ出す
if (firebaseConfig.projectId !== "miyabicompany-manager") {
  console.warn("[firebase] 本番ではないプロジェクトに接続しています:", firebaseConfig.projectId);
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
// 社内文書（就業規則など）のファイル本体はFirebase Storageに置く
export const storage = getStorage(app);
